module.exports = __webpack_public_path__ + "img/predicted_salary.d948551f.png";